import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import SizeModifierSelect from '@/common/components/SizeModifierSelect';

const SizeModifierSection = ({ currentSizeId, options, onChange }) => {
    const [t] = useTranslation('product-editor');

    return (
        <>
            <span className="m2g-product-editor-size-label m2g-product-editor-size-label--v2 m2g-product-editor-settings-label">
                {t('size')}
            </span>
            <div
                className="m2g-product-editor-size m2g-input-container"
                data-icon-after="select"
            >
                <SizeModifierSelect
                    className="m2g-product-editor-size-select m2g-select"
                    currentSizeId={currentSizeId}
                    options={options}
                    onChange={onChange}
                />
            </div>
        </>
    );
};

SizeModifierSection.propTypes = {
    currentSizeId: PropTypes.number.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            price: PropTypes.object,
            out_of_stock: PropTypes.bool,
        })
    ).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default SizeModifierSection;
